var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","justify-end":""}},[_c('v-flex',{attrs:{"shrink":""}},[_c('displays-text',{attrs:{"color":"grey","type":"headline","text":_vm.title}})],1),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }